const HIDDEN_KEY = 'FYGR_SUB_MONTHLY_MA_HIDDEN';
const SESSION_KEY = 'FYGR_SUB_MONTHLY_MA_SEEN';

export function subMonthlyForecastNoticeHidden(): boolean {
  return localStorage.getItem(HIDDEN_KEY) === '1';
}

export function hideSubMonthlyForecastNotice(): void {
  localStorage.setItem(HIDDEN_KEY, '1');
}

/**
 * Un ajustement manuel saisi au jour ou à la semaine désaligne la vue mensuelle.
 * On prévient une fois par périodicité et par session — la saisie se fait cellule
 * par cellule — et plus du tout si l'utilisateur a coché « ne plus afficher ».
 */
export function shouldWarnSubMonthly(periodType: string): boolean {
  if (periodType !== 'day' && periodType !== 'week') return false;
  if (subMonthlyForecastNoticeHidden()) return false;
  const seenKey = `${SESSION_KEY}_${periodType}`;
  if (sessionStorage.getItem(seenKey)) return false;
  sessionStorage.setItem(seenKey, '1');
  return true;
}
